import React, { useEffect, useRef, useState } from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import styles from './styles.module.scss'
import RequiredStar from 'srcReact/components/common2/RequiredStar'
import Label from 'srcReact/components/common2/Label'
import ErrorMessage from '../ErrorMessage'

const TextArea = (props) => {
  const {
    cols,
    rows,
    label,
    isRequired,
    onChange,
    onBlur,
    onFocus,
    name,
    placeholder,
    customWrapperCss,
    customLabelCss,
    customInputCss,
    customErrorCss,
    fieldInfo,
    title,
    size,
    options,
    setRef,
    maxLength = '',
    disabled = false,
    showTextLength = false
  } = props

  const inputRef = useRef(null)
  useEffect(() => {
    if (setRef) {
      setRef(inputRef)
    }
  }, [])

  return (
    <div className={`${styles.wrapper} ${customWrapperCss} ${styles[size]}`}>
      {label && (
        <Label ariaLabel={label} className={customLabelCss} htmlFor={name}>
          {label}
          {isRequired && <RequiredStar />}
        </Label>
      )}
      <textarea
        value={fieldInfo.value}
        cols={cols}
        rows={rows}
        id={name}
        name={name}
        ref={inputRef}
        aria-label={label}
        aria-required={isRequired}
        className={`${styles.input} ${fieldInfo && fieldInfo.hasError && styles.inputError}  ${customInputCss}`}
        placeholder={placeholder}
        onChange={(e) => onChange(e)}
        onBlur={(e) => onBlur && onBlur(e)}
        onFocus={(e) => onFocus && onFocus(e)}
        disabled={disabled}
        maxLength={maxLength}
        {...options}
      />
      {fieldInfo && fieldInfo.hasError && (
        <ErrorMessage text={fieldInfo.errorMessage} className={`${styles.error} ${customErrorCss}`} />
      )}
      {showTextLength && <p className={styles.count}>{`${fieldInfo.value?.length || 0}/${maxLength}`}</p>}
    </div>
  )
}

TextArea.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  isRequired: PropTypes.bool,
  customWrapperCss: PropTypes.string,
  customLabelCss: PropTypes.string,
  customInputCss: PropTypes.string,
  customErrorCss: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  labelPosition: PropTypes.string
}

const ExtendedComponent = withTranslation('common')(TextArea)
export { ExtendedComponent as TextArea }
